interface PageHeaderProps {
  pageHeaderTitleProp?: string;
  pageHeaderSubtitleProp?: string;
  pageHeaderWrapperCssClassProp?: string;
  pageHeaderImageProp?: string;
  pageWidthStyle?: string | null | undefined;
  hideHeader?: boolean;
}

export default function PageHeaderWProps({
  pageHeaderTitleProp,
  pageHeaderSubtitleProp,
  pageHeaderWrapperCssClassProp,
  pageHeaderImageProp,
  pageWidthStyle,
  hideHeader,
}: PageHeaderProps) {
  if (hideHeader === true) return <div />;

  return (
    <div>
      <section
        className={`contentPage-body dark-section ${
          pageWidthStyle === 'Full'
            ? 'w-full py-4 overflow-x-hidden'
            : 'container my-8 md:mt-6 md:mb-8 mx-auto w-10 lg:w-10 xl:w-10 true'
        }`}>
        <section
          className={`hero-container ${
            !!pageHeaderWrapperCssClassProp && pageHeaderWrapperCssClassProp
          }`}
          style={{
            backgroundImage: `url(${
              !!pageHeaderImageProp && pageHeaderImageProp
            })`,
          }}>
          <div className="hero-text-content-page flex flex-column align-items-center justify-content-center py-4">
            {!!pageHeaderTitleProp && (
              <h1 className="text-3xl md:text-5xl xl:text-8xl text-shadow my-0 py-0">
                {pageHeaderTitleProp}
              </h1>
            )}
            {!!pageHeaderSubtitleProp && (
              <h2 className="text-shadow my-0 py-0 text-center">
                {pageHeaderSubtitleProp}
              </h2>
            )}
          </div>
        </section>
      </section>
    </div>
  );
}
